import {
  Intercom, onShow, onHide,
  boot,
} from '@intercom/messenger-js-sdk';
import Api from '@/lib/api-wrapper';

async function getIntercomJwt() {
  try {
    const response = await Api.axios.get('/dashboard/intercom-jwt', {
      withCredentials: true,
    });

    return response.intercomJwtToken;
  } catch (error) {
    log('Error getting Intercom JWT:', error);
    return null;
  }
}

export default async function bootIntercom(user) {
  if (!process.env.VUE_APP_INTERCOM_APP_ID) return;

  log('Booting Intercom with user:', user);

  const isAuthenticated = window.Knack?.Api?.user_id;
  const intercomConfig = {
    app_id: process.env.VUE_APP_INTERCOM_APP_ID,
    ...user,
  };
  const bootOptions = {
    hide_default_launcher: true,
  };

  if (isAuthenticated) {
    try {
      const intercomJwtToken = await getIntercomJwt();
      if (intercomJwtToken) {
        bootOptions.intercom_user_jwt = intercomJwtToken;
      }
    } catch (error) {
      log('Failed to get Intercom JWT, continuing without it:', error);
    }
  }

  Intercom(intercomConfig);

  boot(bootOptions);

  onShow(() => {
    document.dispatchEvent(new CustomEvent('intercom-opened'));
  });

  onHide(() => {
    document.dispatchEvent(new CustomEvent('intercom-closed'));
  });
}
